module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.level === 2) ? _c('h2', {
    class: [_vm.font, _vm.color, _vm.variant]
  }, [_vm._v(_vm._s(_vm.text))]) : _c('h3', {
    class: [_vm.font, _vm.color, _vm.variant]
  }, [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1b0e6e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Heading.vue
// module id = 283
// module chunks = 0